import { api as dataEnteringApi } from "../api";

export interface StartSessionResponse {
    accountId: number;
    documentId: number;
}

export const sessionApi = dataEnteringApi.injectEndpoints({
    endpoints: (build) => ({
        startSession: build.mutation<StartSessionResponse, void>({
            query: () => ({
                url: "api/v1/data_entering/start",
                method: "POST",
            }),
        }),
    }),
});
